import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ThoughtShard from './pages/ThoughtShard';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/thoughtshard" element={<ThoughtShard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;